import { LegalLayout, Section } from "@/components/LegalLayout";
import { CONTACT } from "@/data";

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" updated="August 2026">
      <p className="font-body text-navy/75 text-lg leading-relaxed">
        This Privacy Policy explains what information {CONTACT.name} collects through this website and
        how we use it. We keep things simple: we only collect what we need to give you a quote and do
        the work.
      </p>

      <Section heading="Information We Collect">
        <p>When you submit the quote form, we collect:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Your name, phone number and email address</li>
          <li>The service you're interested in and any details you share</li>
          <li>Any photos you choose to upload</li>
        </ul>
      </Section>

      <Section heading="How We Use It">
        <p>
          We use your information only to respond to your request, prepare and send your quote,
          schedule and complete work, and communicate with you about your project. We do not sell your
          information to anyone.
        </p>
      </Section>

      <Section heading="Service Providers">
        <p>
          To run our business we use trusted third-party tools. For example, we may pass your quote
          details and photos to <strong>Jobber</strong>, our scheduling and invoicing software, so we
          can manage your job and send your invoice. These providers only receive the information
          needed to perform their service and are bound by their own privacy terms.
        </p>
      </Section>

      <Section heading="Data Retention">
        <p>
          We keep your request information for as long as needed to serve you and for reasonable
          business records. You can ask us to delete your information at any time.
        </p>
      </Section>

      <Section heading="Your Choices">
        <p>
          You can request access to, correction of, or deletion of your information by contacting us.
          Uploading photos is always optional.
        </p>
      </Section>

      <Section heading="Contact">
        <p>
          To make a privacy request or ask a question, call or text{" "}
          <a href={CONTACT.phoneHref} className="text-navy underline hover:text-gold">{CONTACT.phone}</a>{" "}
          or email{" "}
          <a href={`mailto:${CONTACT.email}`} className="text-navy underline hover:text-gold">{CONTACT.email}</a>.
        </p>
      </Section>
    </LegalLayout>
  );
}
